const texts = {
  hero: {
    english: 'Augusto Alves',
    portuguese: 'Augusto Alves',
  },
  heroSentence: {
    english: 'Web Developer / From Brazil',
    portuguese: 'Desenvolvedor Web / Do Brasil 🧡',
  },
  menu: {
    english: {
      About: 'About',
      MySkills: 'My Skills',
      Projects: 'Projects',
      Contact: 'Contact',
    },
    portuguese: {
      About: 'Sobre',
      MySkills: 'Habilidades',
      Projects: 'Projetos',
      Contact: 'Contato',
    },
  },
  contactButon: {
    english: 'Contact me!',
    portuguese: 'Entre em contato!',
  },
  projects: {
    english: {
      title: 'Made by me',
      text: 'Some of the projects presented here were selected by me, mostly made for the course',
      tech: 'Stacks',
    },
    portuguese: {
      title: 'Feito por mim',
      text: 'Alguns dos meus projetos escolhidos por mim, em sua maioria são projetos feitos para o curso ',
      tech: 'Tecnologias',
    },
  },
  contact: {
    english: {
      name: 'Your Name',
      email: 'Email',
      textArea: 'Your message',
      button: 'Send',
      sendedButton: 'Sended!',
      h2: 'Get in toutch!',
    },
    portuguese: {
      name: 'Seu Nome',
      email: 'Email',
      textArea: 'Sua mensagem',
      button: 'Enviar',
      sendedButton: 'Enviado!',
      h2: 'Entre em contato!',
    },
  },
  contactSentence: {
    english: 'If want to work with me, get in toutch. And if you just want talk, feel free.',
    portuguese: 'Se quiser trabalhar comigo só entrar em contato por aqui. E se quiser também só trocar uma ideia, fica a vontade.',
  },
  about: {
    english: {
      sentenceOne: 'Brazilian and in love with technology. Web development student at Trybe who likes to solve complex problems',
      sentenceTwo: 'Well-organized person, in constant learning and with a lot of attention to detail.',
      sentenceThree: 'Interested in entire web development spectrum and working in projects who change the people’s lifes',
    },
    portuguese: {
      sentenceOne: 'Carioca e apaixonado por tecnologia. Estudante de desenvolvimento web na Trybe que gosta de resolver problemas complexos.',
      sentenceTwo: 'Pessoa bem organizada, em constante aprendizado e com muita atenção aos detalhes.',
      sentenceThree: 'Interessado em todo o espectro do desenvolvimento web e trabalhar em projetos que mudem a vida das pessoas.',
    },
  },
};

export default texts;
